<template>
  <div :editing="editing" class="track-and-trace-header-editor row">
    <template v-if="editing">
      <div class="col-12 ">
        <div class="logo-placeholder">
          <label for="">{{ $t('trackAndTrace.header.logo') }}</label>
          <div class="logo-drag-drop-container">
            <DragAndDropContainer ref="dragAndDropContainer"
                                  :numberOfFilesAllowed="1"
                                  :allowedFileSize="'5MB'"
                                  :showFailedToast="true"
                                  :deletable="false"
                                  :showSuccessToast="false"
                                  :uploadedFiles="getLogoFile"
                                  :path="getTrackAndTraceFilePath"
                                  :hide-manual-button="true"
                                  :hide-library="true"
                                  :accepted-file-types="'image/*'"
                                  :help-text="$t('trackAndTrace.header.placeholders.dagAndDropHelpText')"
            ></DragAndDropContainer>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="page-title-edit" v-if="editing">
          <label for="title-planning">{{ $t('trackAndTrace.header.secretKey') }}</label>
          <input type="text" class="track-and-trace-banner-title-input form-control"
                 :placeholder="$t('trackAndTrace.header.placeholders.secretKey')" v-model="secretKeyLabelModel">
        </div>
      </div>
    </template>

    <div class="track-and-trace-logo" v-if="!editing">
      <img :src="downloadUrl" class="logo-img" v-if="getLogoFile.length"/>
      <img src="@/assets/Logo-2022-Motivate.png" class="logo-img" v-else-if="!getLogoFile.length"/>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import DragAndDropContainer from "@/components/filemanager/DragAndDropContainer";
import firebase from "firebase";

export default {
  name: "TackAndTraceHeader",
  props: ['editing', 'customRoute'],
  components: {DragAndDropContainer},
  data() {
    return {
      downloadUrl: null,
      secretKeyLabel: ''
    }
  },
  computed: {
    ...mapGetters('trackAndTrace', ['getTrackAndTraceConfig']),
    getRouteIndex() {
      if (!this.customRoute) {
        return null;
      }
      const routes = this.getTrackAndTraceConfig.customRoutes || [];
      const index = routes.indexOf(this.customRoute);
      return index === -1 ? null : index;
    },
    routeHasOwnLogo() {
      return !!(this.customRoute && this.customRoute.logoFileName);
    },
    getResolvedLogoFileName() {
      return this.routeHasOwnLogo ? this.customRoute.logoFileName : this.getTrackAndTraceConfig.logoFileName;
    },
    getMainStoragePath() {
      const companyId = this.getTrackAndTraceConfig.companyId;
      const configId = this.getTrackAndTraceConfig.id;
      return `trackAndTrace/${companyId}/${configId}`;
    },
    getRouteStoragePath() {
      return `${this.getMainStoragePath}/routes/${this.getRouteIndex}`;
    },
    getLogoFile() {
      if (!this.getTrackAndTraceConfig || !this.getResolvedLogoFileName) {
        return [];
      } else {
        const storagePath = this.routeHasOwnLogo ? this.getRouteStoragePath : this.getMainStoragePath;
        return [{
          bucket: 'performance-management-tool.appspot.com',
          color: null,
          fullPath: `${storagePath}/${this.getResolvedLogoFileName}`,
          name: this.getResolvedLogoFileName,
          type: 'image/*'
        }]
      }
    },
    getTrackAndTraceFilePath() {
      // Destination for NEW uploads: the route's own folder when editing a route, else main.
      return this.customRoute ? this.getRouteStoragePath : this.getMainStoragePath;
    },
    secretKeyLabelModel: {
      get() {
        if (!this.customRoute) {
          return this.secretKeyLabel;
        }
        if (this.editing) {
          return this.customRoute.secretKeyLabel;
        }
        const routeValue = this.customRoute.secretKeyLabel;
        return (routeValue !== null && routeValue !== undefined) ? routeValue : this.getTrackAndTraceConfig.secretKeyLabel;
      },
      set(value) {
        if (this.customRoute) {
          this.$set(this.customRoute, 'secretKeyLabel', value);
        } else {
          this.secretKeyLabel = value;
        }
      }
    }
  },
  methods: {
    async getDownloadURLFromBucket() {
      const logoFile = this.getLogoFile;
      if (logoFile.length) {
        const path = logoFile[0].fullPath;
        const fileRef = firebase
            .storage()
            .ref(`${path}`);
        this.downloadUrl = await fileRef.getDownloadURL();
      }
    }
  },
  created() {
    this.getDownloadURLFromBucket();
    this.secretKeyLabel = this.getTrackAndTraceConfig.secretKeyLabel ?  this.getTrackAndTraceConfig.secretKeyLabel : this.secretKeyLabel;
  },
  watch: {}
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/MotivateColors";

$headerHeight: 48px;

.language-selector {
  display: inline-block;
  position: relative;
  right: 0px;
}

.track-and-trace-header-editor {
  background: $walterWhite;
  padding-left: 34px;
  padding-right: 34px;
  margin: 0px;
}


.track-and-trace-header {
  height: $headerHeight;
  background: $walterWhite;
  padding-left: 48px;
  padding-right: 48px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(15rem, auto));
  align-items: center;

}

.track-and-trace-header[editing=true] {
  height: calc(#{$headerHeight} * 2);
}

.logo-img {
  height: 39px;
  margin-top: calc((#{$headerHeight} - 39px) / 2 - 0.5rem);
}

.logo-drag-drop-container {
  width: 400px;
}

/deep/ .file-preview {
  height: calc(#{$headerHeight} - 2px - 2px - 2px - 2px - 2px) !important; // The 2px minusses are the padding/margin of the plugin

  .file-name {
    font-size: 0.875rem;
  }

  .file-ext, .file-size {
    font-size: 0.75rem;
  }


  span {
    line-height: unset !important;

    svg {
      display: none;
    }

    .help-text {
      left: 0px !important;
    }
  }
}

.logo-drag-drop-container {
  margin-bottom: 12px;
}

.language-selector {
  width: 100%;
}
</style>